<div class="card shadow-sm rounded-3">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
          <i class="las la-money-check-alt me-2"></i> {{ 'BALANCE.ENTER_PAYMENTS' | translate }}
        </h4>
        <p class="text-muted mt-2 mb-0">
          {{ 'BALANCE.ENTER_PAYMENTS_HINT' | translate }}
        </p>
      </div>
      <div>
<!--        <h4 class="fw-bold text-dark m-0 d-flex align-items-center">-->
<!--          {{ renter | renterName }}-->
<!--        </h4>-->
<!--        <h5 class="text-primary text-end mt-2">0,00 €</h5>-->
      </div>
    </div>
    <div class="mt-4">
      <p-table
        [hasList]="service.hasList"
        (onLazyLoad)="loadData($event)"
        (onPage)="pageChange($event)"
        [columns]="service.tableColumns"
        [first]="first"
        [loading]="loading()"
        [rows]="rows"
        [totalRecords]="total"
        [value]="list"
        [hasEdit]="false"
        [hasView]="false"
        paginatorPosition="bottom"
        selectionMode="single"
        dataKey="id"
        tableStyleClass="table table-hover"
      >
        <ng-template pTemplate="body" let-data let-expanded="expanded">
          <tr style="vertical-align: middle">
            @for (col of service.tableColumns; track col) {
              @switch (col.fieldName) {
                @case ('collapse') {
                  <td [style.width]="col.width">
                    <button
                      class="btn btn-link"
                      (click)="toggleRow(data)"
                    >
                      @if (isExpanded(data)) {
                        <i class="las la-chevron-down"></i>
                      } @else {
                        <i class="las la-chevron-right"></i>
                      }
                    </button>
                  </td>
                }
                @case ('actions') {
                  <td>
                    <a (click)="addBalance(data)" pTooltip="{{'BALANCE.ADD_BALANCE'|translate}}" tooltipPosition="bottom" class="cursor-pointer">
                    <span class="text-primary">
                      {{ 'BALANCE.ADD_BALANCE' | translate }}
                    </span>
                    </a>
                  </td>
                }
                @case ('renter') {
                  <td>{{ data.renter | renterName }}</td>
                }
                @default {
                  <td>
                    <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
                  </td>
                }
              }
            }
          </tr>
          @if(isExpanded(data)) {
            @for (payment of data.payment; track payment) {
              <tr class="second-level" style="vertical-align: middle">
                <td style="width: 5%"></td>
                <td>{{ payment.date }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ payment.amount | moneyFormat }}</td>
                <td></td>
                <td class="d-flex gap-2">
                  <button class="btn btn-link p-0" (click)="editPayment(data, payment)" [ngbTooltip]="'EDIT'| translate">
                    <i class="bi bi-pencil-square la-2x"></i>
                  </button>
                  <button class="btn btn-link p-0" (click)="onDelete(payment)" [ngbTooltip]="'DELETE'| translate">
                    <i class="las la-trash-alt la-2x"></i>
                  </button>
                </td>
              </tr>
            }
          }
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
